<div class="d-flex justify-content-end">
  <button
    *ngIf="addNewAssessment && !updateAssessmentData"
    (click)="addNewAssessment = false"
    class="add-question-btn py-2 v4-btn-every"
  >
    {{ "Back" | translator }}
  </button>
</div>
<app-assessment
  *ngIf="addNewAssessment"
  [assessmentTypeId]="'65be1be32d7710d9e377d543'"
  (newAssess)="addedNewAssessmentSession()"
  [fromTraining]="true"
  [trainingTypeId]="trainingTypeId"
></app-assessment>

<section
  [formGroup]="assessmentForm"
  class="row m-0 grey-box"
  [hidden]="addNewAssessment"
>
  <h4 class="color font-600 bottom-line" [ngClass]="{ 'color-red': true }">
    <i class="fa-solid fa-square-poll-horizontal ml-2 mr-2 location"></i
    >{{ "Choose a test" | translator }}
  </h4>

  <div class="col-lg-6 col-md-6 col-12 my-2">
    <label class="label-ui" for="start_date"
      ><i class="fa-solid fa-calendar-days ml-2 mr-2 result-icons"></i>
      {{ "Start Date" | translator }}&nbsp;:&nbsp;</label
    >
    <p-calendar
      [minDate]="today"
      [showTime]="true"
      [touchUI]="true"
      appendTo="body"
      class="w-100 mb-3"
      formControlName="start_date"
      [readonlyInput]="true"
    ></p-calendar>
    <div class="error" *ngIf="isFieldError('start_date')">
      <div>{{ "Date is required" | translator }}</div>
    </div>
  </div>
  <div
    class="col-lg-6 col-md-6 col-12 my-2"
    *ngIf="!!assessmentForm.get('start_date')?.getRawValue()"
  >
    <label class="label-ui" for="end_date"
      ><i class="fa-regular fa-clock ml-2 mr-2 result-icons"></i>
      {{ "End Date" | translator }}&nbsp;:&nbsp;</label
    >
    <p-calendar
      [minDate]="startDate"
      [showTime]="true"
      [touchUI]="true"
      appendTo="body"
      id="end_date"
      formControlName="end_date"
      class="w-100 mb-3"
    ></p-calendar>
    <div class="error" *ngIf="isFieldError('end_date')">
      <div>{{ "start time is required" | translator }}</div>
    </div>
  </div>

  <div class="flex-mob-web my-2">
    <div class="m-1">
      <p-selectButton
        class="v4-active d-flex justify-content-end"
        [options]="blockOptions"
        formControlName="video_mode"
        optionLabel="name"
        optionValue="value"
      ></p-selectButton>
    </div>
    <div class="m-1">
      <button (click)="addNewAssessment = true" class="ms-btn-onclick">
        {{ "Add Assessment" | translator
        }}<i class="pi pi-plus-circle mx-2"></i>
      </button>
    </div>
  </div>

  <div
    class="col-lg-4 col-md-6 col-12 my-2 p-0"
    *ngFor="let assessment of assessments"
  >
    <div
      class="card card-shaddow m-1"
      [ngClass]="{
        'dynamic-card-active': selectedAssessment?._id == assessment._id
      }"
      (click)="
        selectedAssessment = assessment;
        assessmentForm.get('assessmentId')?.setValue(assessment._id)
      "
    >
      <h4 class="label-ui mt-2">
        <i class="fa-solid fa-chart-line ml-2 mr-2 result-icons"></i
        >{{ assessment.assessmentTitle }}
      </h4>
      <p class="label-data m-0">{{ assessment.assessmentTitle }}</p>
      <span class="scroll-desc">
        <p class="label-text">{{ assessment.description }}</p>
      </span>
      <button
        class="v4-btn-every py-2 mb-2"
        (click)="openAddQuestion(assessment)"
      >
        <i class="pi pi-external-link v4-ml-2"></i
        >{{ "Add Questions" | translator }}
      </button>
    </div>
  </div>
</section>
<div class="error" *ngIf="isFieldError('assessmentId')">
  <div>{{ "Please Select an assessment" | translator }}</div>
</div>
<div class="d-flex justify-content-center" *ngIf="!addNewAssessment">
  <button
    type="button"
    (click)="createAssessmentSession()"
    class="ms-btn-onclick mb-ten"
  >
    {{ "OK" | translator }}<i class="fa-regular fa-pen-to-square mx-2"></i>
  </button>
</div>
